import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { TableSkeletonContent } from "../Skeletons/skeletons.js";

export interface EntityTableEmptyStateProps {
  className?: string;
  isLoading?: boolean;
  isError?: boolean;
  children: ReactNode;
}

export const EntityTableEmptyState: FC<EntityTableEmptyStateProps> = (
  props,
) => {
  if (props.isLoading) {
    return <TableSkeletonContent className={props.className} />;
  }

  if (props.isError) {
    return (
      <div
        className={twMerge(
          "px-3 py-9 text-center text-sm font-semibold text-red-700",
          props.className,
        )}
      >
        We couldn't load this data. Please refresh to try again.
      </div>
    );
  }

  return (
    <div
      className={twMerge(
        "px-3 py-9 text-center text-sm font-semibold text-foreground",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};
